import React from "react";

// reactstrap components
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardTitle,
  Container,
  Row,
  Col,
} from "reactstrap";

import { Link } from 'react-router-dom'


// core components
import WebHeader from "components/Headers/Custom/WebHeader.js";
import ColorNavbar from "components/Navbars/ColorNavbar"; import ContactComponent from './ContactComponent.js'

import FooterNav from "./FooterNav.js";
import Divider from "../sections-sections/Divider.js";


function WebDevelopment() {
  document.documentElement.classList.remove("nav-open");
  // function that is being called on scroll of the page
  const checkScroll = () => {
    // it takes all the elements that have the .add-animation class on them
    const componentPosition = document.getElementsByClassName("add-animation");
    const scrollPosition = window.pageYOffset;
    for (var i = 0; i < componentPosition.length; i++) {
      var rec =
        componentPosition[i].getBoundingClientRect().top + window.scrollY + 100;
      // when the element with the .add-animation is in the scroll view,
      // the .animated class gets added to it, so it creates a nice fade in animation
      if (scrollPosition + window.innerHeight >= rec) {
        componentPosition[i].classList.add("animated");
        // when the element with the .add-animation is not in the scroll view,
        // the .animated class gets removed from it, so it creates a nice fade out animation
      } else if (scrollPosition + window.innerHeight * 0.8 < rec) {
        componentPosition[i].classList.remove("animated");
      }
    }
  };

  React.useEffect(() => {
    document.body.classList.add("presentation-page");
    window.addEventListener("scroll", checkScroll);
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("presentation-page");
      window.removeEventListener("scroll", checkScroll);
    };
  });
  return (
    <>
      <ColorNavbar />
      <WebHeader />
      <div className="wrapper">
       
      
      <Row>
      
                    <Col md="7">
                    <Link to="/custom-software">
                      <div className="topcard">
                        <h1 id="titleblack">
                        What We Offer
                        </h1>
                       
                      </div>
                    
              </Link>
                    </Col>
                    <Col md="4">
                      
                  <p className="top-description">
                  Striking a delicate balance between the intuitive and the analytical, world-class product and 
                  service design is about science as much as beauty. Using human-centered design tools, we create 
                  digital products that help organizations enhance the value they provide to people.
                  </p>
                 
                    </Col> 
                </Row>
               
                <div className="webdiv shift-up-200px">
                  
                  

                <Row className="col-container">
                  
                <Col lg="8" md="8" sm="12" className="">

                <Divider dividerHeading="divider__heading1" divTitle="Websites" />

                  </Col>
                
                  <Col lg="4" md="4" sm="6" xs="12" className="col3">
              <div className="card-big-shadow">
              <Link to="/basic-website-packages">
                <Card
                  className="webcard"
                >
                  <CardBody>
                  <hr className="h-line4" />
                    <CardTitle tag="h5">
                      <div className="webcardicon">
                      <img 
                        alt="basic website"
                        className="webcardimg"
                        src={require("assets/img/nlicons/web/widget1.svg")}
                        />
                        <span>
                        <h5 className="webcardtitle">
                        Starter Website Solutions
                      </h5>
                        </span>
                  
                      </div>
                      
                    </CardTitle>
                    <br></br>
                    <p className="card-description">
                    Modern, mobile-friendly sites crafted for individuals or start-ups. Includes easy content management options.
                    </p>
                  </CardBody>
                  <CardFooter>
                  <Link to="/basic-website-packages">
                  <Button
                      className="btn-link" id="colorviolet2"
                      
                    >
                      See more
                    </Button>
                    </Link>
                  </CardFooter>
                </Card>
                </Link>
              </div>
            </Col>

          </Row>

          <Row>


            <Col lg="4" md="4" sm="6" xs="12" className="col3">
              <div className="card-big-shadow">
              <Link to="/business-website-packages">
                <Card
                  className="webcard h-100"
                >
                  <CardBody>
                  <hr className="h-line4" />
                    <CardTitle tag="h5">
                    <div className="webcardicon">
                      <img 
                        alt="business website"
                        className="webcardimg"
                        src={require("assets/img/nlicons/web/widget2.svg")}
                        />
                        <span>
                        <h5 className="webcardtitle">
                        Business Website Solutions
                      </h5>
                        </span>
                  
                      </div>
                    </CardTitle>
                    <br></br>
                    <p className="card-description">
                    Professional websites tailored for growing companies, featuring dynamic content and ecommerce integrations.
                    </p>
                    
                  </CardBody>
                  <CardFooter>
                  <Link to="/business-website-packages">
                  <Button
                      className="btn-link" id="colorviolet2"
                      
                    >
                      See more
                    </Button>
                    </Link>
                  </CardFooter>
                </Card>
                </Link>
              </div>
            </Col>
            <Col lg="4" md="4" sm="6" xs="12" className="col3">
              <div className="card-big-shadow">
              <Link to="/ecommerce-packages">
                <Card
                  className="webcard h-100"
                  
                >
                  <CardBody>
                  <hr className="h-line4" />
                    <CardTitle tag="h5">
                    <div className="webcardicon">
                      <img 
                        alt="ecommerce website"
                        className="webcardimg"
                        src={require("assets/img/nlicons/web/cart-simple1.svg")}
                        />
                        <span>
                        <h5 className="webcardtitle">
                        Ecommerce Solutions
                      </h5>
                        </span>
                  
                      </div>
                    </CardTitle>
                    <br></br>
                    <p className="card-description">
                    Robust online stores with inventory tools and point‑of‑sale integration for smooth transactions.
                    </p>
                    
                 </CardBody>
                  <CardFooter>
                  <Link to="/ecommerce-packages">
                  <Button
                      className="btn-link" id="colorviolet2"
                      
                    >
                      See more
                    </Button>
                    </Link>
                  </CardFooter>
                </Card>
                </Link>
              </div>
            </Col>

            <Col lg="4" md="4" sm="6" xs="12" className="col3">
              <div className="card-big-shadow">
              <Link to="/custom-website-packages">
                <Card
                  className="webcard h-100"
                >
                  <CardBody>
                  <hr className="h-line4" />
                    <CardTitle tag="h5">
                    <div className="webcardicon">
                      <img 
                        alt="custom website"
                        className="webcardimg"
                        src={require("assets/img/nlicons/web/widget3.svg")}
                        />
                        <span>
                        <h5 className="webcardtitle">
                        Custom Development Solutions
                      </h5>
                        </span>
                  
                      </div>
                      
                    </CardTitle>
                    <br></br>
                    <p className="card-description">
                      Fully bespoke sites and web applications built to your specifications.
                    </p>
                    
                 </CardBody>
                  <CardFooter>
                  <Link to="/custom-website-packages">
                  <Button
                      className="btn-link" id="colorviolet2"
                      
                    >
                      See more
                    </Button>
                    </Link>
                  </CardFooter>
                </Card>
                </Link>
              </div>
            </Col>
                  </Row>

             
                  <Row className="shift-up-100px-0px">
                  <Col lg="12" md="12" sm="12">
              <Divider dividerHeading="divider__heading" divTitle="Digital Marketing" />
                  </Col>
                  </Row>
                  <Row>
                  
           
                
                  
            <Col lg="4" md="4" sm="6" xs="12" className="col3">
              <div className="card-big-shadow">
              <Link to="/adwords">
                <Card
                  className="webcard"
                  >
                 <CardBody>
                  <hr className="h-line4" />
                    <CardTitle tag="h5">
                    <div className="webcardicon">
                      <img 
                        alt="website"
                        className="webcardimg"
                        src={require("assets/img/nlicons/web/zoom-2.svg")}
                        />
                        <span>
                        <h5 className="webcardtitle">
                        Google Ads Campaigns
                      </h5>
                        </span>
                  
                      </div>
                      
                    </CardTitle>
                    <br></br>
                    <p className="card-description">
                      Targeted pay‑per‑click strategies combined with SEO to drive quality traffic.
                    </p>
                 </CardBody>
                  <CardFooter>
                  <Link to="/adwords">
                  <Button
                      className="btn-link" id="colorviolet2"
                      
                    >
                      See more
                    </Button>
                    </Link>
                  </CardFooter>
                </Card>
                </Link>
              </div>
            </Col>

            <Col lg="4" md="4" sm="6" xs="12" className="col3 ipad-col">
              <div className="card-big-shadow">
              <Link to="/seo">
                <Card
                  className="webcard"
                  >
                  <CardBody>
                  <hr className="h-line4" />
                    <CardTitle tag="h5">
                      
                    <div className="webcardicon">
                    <img 
                        alt="website"
                        className="webcardimg-seo"
                        src={require("assets/img/nlicons/web/link-72.svg")}
                        />
                        <span>
                        <h5 className="webcardtitle">
                        Search Engine Optimisation
                      </h5>
                        </span>
                  
                      </div>
                      
                    </CardTitle>
                    <br></br>
                    <p className="card-description">
                    We refine your site structure and build quality links to improve natural rankings.
                    </p>
                   
                 </CardBody>
                  <CardFooter>
                  <Link to="/seo">
                  <Button
                      className="btn-link" id="colorviolet2"
                      
                    >
                      See more
                    </Button>
                    </Link>
                  </CardFooter>
                </Card>
                </Link>
              </div>
            </Col>

            <Col lg="4" md="4" sm="6" xs="12" className="col3">
              <div className="card-big-shadow">
              <Link to="/social-media">
                <Card
                  className="webcard"
                  >
                 <CardBody>
                  <hr className="h-line4" />
                    <CardTitle tag="h5">
                    <div className="webcardicon">
                      <img 
                        alt="website"
                        className="webcardimg"
                        src={require("assets/img/nlicons/web/multiple-11.svg")}
                        />
                        <span>
                        <h5 className="webcardtitle">
                        Social Media Marketing 
                      </h5>
                        </span>
                  
                      </div>
                      
                    </CardTitle>
                    <br></br>
                    <p className="card-description">
                      Utilise platforms like Facebook, Instagram and YouTube to build brand awareness and reach new customers.
                    </p>
                 </CardBody>
                  <CardFooter>
                  <Link to="/social-media">
                  <Button
                      className="btn-link" id="colorviolet2"
                      
                    >
                      See more
                    </Button>
                    </Link>
                  </CardFooter>
                </Card>
                </Link>
              </div>
            </Col>
            </Row>
            
           


                  <Row className="">
                <Col lg="12" md="12" sm="12">
                <Divider dividerHeading="divider__heading2" divTitle="Hosting & Maintenance" />

               
                </Col>
              </Row>


                  <Row>
                  
           
                
                  <Col lg="4" md="4" sm="6" xs="12" className="col3">
              <div className="card-big-shadow">
              <Link to="/web-hosting">
                <Card
                  className="webcard"
                  >
                 <CardBody>
                  <hr className="h-line4" />
                    <CardTitle tag="h5">
                    <div className="webcardicon">
                      <img 
                        alt="website"
                        className="webcardimg"
                        src={require("assets/img/nlicons/web/world.svg")}
                        />
                        <span>
                        <h5 className="webcardtitle">
                        Web Hosting Services
                      </h5>
                        </span>
                  
                      </div>
                      
                    </CardTitle>
                    <br></br>
                    <p className="card-description">
                    Reliable hosting and email solutions with plans to suit all business sizes.
                    </p>
                    
                 </CardBody>
                  <CardFooter>
                  <Link to="/web-hosting">
                  <Button
                      className="btn-link" id="colorviolet2"
                      
                    >
                      See more
                    </Button>
                    </Link>
                  </CardFooter>
                </Card>
                </Link>
              </div>
            </Col>
            <Col lg="4" md="4" sm="6" xs="12" className="col3 ipad-col">
              <div className="card-big-shadow">
              <Link to="/website-maintenance">
                <Card
                  className="webcard"
                  >
                 <CardBody>
                  <hr className="h-line4" />
                    <CardTitle tag="h5">
                    <div className="webcardicon">
                      <img 
                        alt="website"
                        className="webcardimg"
                        src={require("assets/img/nlicons/web/dashboard-level.svg")}
                        />
                        <span>
                        <h5 className="webcardtitle">
                        Website Maintenance Plans
                      </h5>
                        </span>
                  
                      </div>
                     
                    </CardTitle>
                    <br></br>
                    <p className="card-description">
                      Keep your website secure and up-to-date with regular backups and plugin updates.
                    </p>
                    
                 </CardBody>
                  <CardFooter>
                  <Link to="/website-maintenance">
                  <Button
                      className="btn-link" id="colorviolet2"
                      
                    >
                      See more
                    </Button>
                    </Link>
                  </CardFooter>
                </Card>
                </Link>
              </div>
            </Col>
            <Col lg="4" md="4" sm="6" xs="12" className="col3">
              <div className="card-big-shadow">
              <Link to="/web-security">
                <Card
                  className="webcard"
                >
                 <CardBody>
                  <hr className="h-line4" />
                    <CardTitle tag="h5">
                    <div className="webcardicon">
                      <img 
                        alt="security"
                        className="webcardimg"
                        src={require("assets/img/nlicons/web/lock.svg")}
                        />
                        <span>
                        <h5 className="webcardtitle">
                        Security & SSL
                      </h5>
                        </span>
                  
                      </div>
                    </CardTitle>
                    <br></br>
                    <p className="card-description">
                      Comprehensive site security audits and HTTPS setup for peace of mind.
                    </p>
                    <br></br>
                    
                 </CardBody>
                  <CardFooter>
                  <Link to="/web-security">
                  <Button
                      className="btn-link" id="colorviolet2"
                      
                    >
                      See more
                    </Button>
                    </Link>
                  </CardFooter>
                </Card>
                </Link>
              </div>
            </Col>
           
            
                  </Row>

                  <Row className="shift-up-100px-0px">
                <Col lg="12" md="12" sm="12">
                <Divider dividerHeading="divider__heading3" divTitle="Digital Design" />

                </Col>
              </Row>


                  <Row>
                   
                  <Col lg="4" md="4" sm="6" xs="12" className="col3">
              <div className="card-big-shadow">
              <Link to="/content-creation">
                <Card
                  className="webcard"
                  >
                 <CardBody>
                  <hr className="h-line4" />
                    <CardTitle tag="h5">
                    <div className="webcardicon">
                      <img 
                        alt="website"
                        className="webcardimg"
                        src={require("assets/img/nlicons/web/pencil.svg")}
                        />
                        <span>
                        <h5 className="webcardtitle">
                        Content Creation
                      </h5>
                        </span>
                  
                      </div>
                      
                    </CardTitle>
                    <br></br>
                    <p className="card-description">
                    Experienced writers craft engaging copy tailored to your audience.
                    </p>
                    <br></br>
                    <br></br>
                 </CardBody>
                  <CardFooter>
                  <Link to="/content-creation">
                  <Button
                      className="btn-link" id="colorviolet2"
                      
                    >
                      See more
                    </Button>
                    </Link>
                  </CardFooter>
                </Card>
                </Link>
              </div>
            </Col>
            <Col lg="4" md="4" sm="6" xs="12" className="col3">
              <div className="card-big-shadow">
              <Link to="/graphic-design">
                <Card
                  className="webcard"
                  >
                 <CardBody>
                  <hr className="h-line4" />
                    <CardTitle tag="h5">
                    <div className="webcardicon">
                      <img 
                        alt="website"
                        className="webcardimg"
                        src={require("assets/img/nlicons/web/vector.svg")}
                        />
                        <span>
                        <h5 className="webcardtitle">
                        Graphic Design
                      </h5>
                        </span>
                  
                      </div>
                      
                    </CardTitle>
                    <br></br>
                    <p className="card-description">
                        Logo and brand assets designed to captivate your customers.
                    </p>
                    <br></br>
                 </CardBody>
                  <CardFooter>
                  <Link to="/graphic-design">
                  <Button
                      className="btn-link" id="colorviolet2"
                      
                    >
                      See more
                    </Button>
                    </Link>
                  </CardFooter>
                </Card>
                </Link>
              </div>
            </Col>
            <Col lg="4" md="4" sm="6" xs="12" className="col3">
              <div className="card-big-shadow">
              <Link to="/corporate-identity">
                <Card
                  className="webcard"
                  >
                 <CardBody>
                  <hr className="h-line4" />
                    <CardTitle tag="h5">
                    <div className="webcardicon">
                      <img 
                        alt="website"
                        className="webcardimg"
                        src={require("assets/img/nlicons/web/check-circle-07.svg")}
                        />
                        <span>
                        <h5 className="webcardtitle">
                        Corporate Identity
                      </h5>
                        </span>
                  
                      </div>
                      
                    </CardTitle>
                    <br></br>
                    <p className="card-description">
                      Consistent branding across all your communication channels.
                    </p>
                    
                 </CardBody>
                  <CardFooter>
                  <Link to="/corporate-identity">
                  <Button
                      className="btn-link" id="colorviolet2"
                      
                    >
                      See more
                    </Button>
                    </Link>
                  </CardFooter>
                </Card>
                </Link>
              </div>
            </Col>
            <Col sm="12" md="12" lg="12">
            
            </Col>
            
                  </Row>

                  <Row className="shift-up-100px-0px">
                <Col lg="12" md="12" sm="12">
                <Divider dividerHeading="divider__heading4" divTitle="Training" />

                </Col>
              </Row>


                  <Row>
                   
              <Col lg="4" md="4" sm="6" xs="12" className="col3">
              <div className="card-big-shadow">
              <Link to="/website-maintenance-training">
                <Card
                  className="webcard"
                  >
                 <CardBody>
                  <hr className="h-line4" />
                    <CardTitle tag="h5">
                    <img 
                        alt="website"
                        className="webcardimg"
                        src={require("assets/img/nlicons/web/dashboard-level2.svg")}
                        />
                    <div className="webcardicon">
                      
                        <span>
                        <h5 className="webcardtitle">
                        Website Maintenance Training
                      </h5>
                        </span>
                  
                      </div>
                      
                    </CardTitle>
                    <br></br>
                    <p className="card-description">
                    Learn how to manage your site's content with hands-on guidance.
                    </p>
                    
                 </CardBody>
                  <CardFooter>
                  <Link to="/website-maintenance-training">
                  <Button
                      className="btn-link" id="colorviolet2"
                      
                    >
                      See more
                    </Button>
                    </Link>
                  </CardFooter>
                </Card>
                </Link>
              </div>
            </Col>
            <Col lg="4" md="4" sm="6" xs="12" className="col3">
              <div className="card-big-shadow">
              <Link to="/development-training">
                <Card
                  className="webcard"
                  >
                 <CardBody>
                  <hr className="h-line4" />
                    <CardTitle tag="h5">
                    <img 
                        alt="website"
                        className="webcardimg"
                        src={require("assets/img/nlicons/web/barcode-qr.svg")}
                        />
                    <div className="webcardicon">
                     
                        <span>
                        <h5 className="webcardtitle">
                        Web Development Training
                      </h5>
                        </span>
                  
                      </div>
                      
                    </CardTitle>
                    <br></br>
                    <p className="card-description">
                      Acquire the skills needed to build modern websites from the ground up.
                    </p>
                    
                 </CardBody>
                  <CardFooter>
                  <Link to="/development-training">
                  <Button
                      className="btn-link" id="colorviolet2"
                      
                    >
                      See more
                    </Button>
                    </Link>
                  </CardFooter>
                </Card>
                </Link>
              </div>
            </Col>
            <Col lg="4" md="4" sm="6" xs="12" className="col3">
              <div className="card-big-shadow">
              <Link to="/software-training">
                <Card
                  className="webcard"
                  >
                 <CardBody>
                  <hr className="h-line4" />
                    <CardTitle tag="h5">
                    <img 
                        alt="website"
                        className="webcardimg"
                        src={require("assets/img/nlicons/web/edit-78.svg")}
                        />
                    <div className="webcardicon">
                      
                        <span>
                        <h5 className="webcardtitle">
                        Software Development Workshops
                      </h5>
                        </span>
                  
                      </div>
                      
                    </CardTitle>
                    <br></br>
                    <p className="card-description">
                      Training on modern software tools and development practices.
                    </p>
                    <br></br>
                 </CardBody>
                  <CardFooter>
                  <Link to="/software-training">
                  <Button
                      className="btn-link" id="colorviolet2"
                      
                    >
                      See more
                    </Button>
                    </Link>
                  </CardFooter>
                </Card>
                </Link>
              </div>
            </Col>
            <Col sm="12" md="12" lg="12">
           
            </Col>
            
                  </Row>
                  
                </div>
                <div
          className="pricing-3 custom-software-div"
          style={{
            backgroundImage:
              "url(" + require("assets/img/nlbg/bg3.jpg") + ")",
          }}
        >
          <Container>
          
            <Row>
              <Col className="ml-auto mr-auto" md="12">
                <h2 id="custom-titlewhite">What We Promise</h2>
                <h5 className="custom-whitetext-custom align-left mx-20">
                NEXTLEVEL Technology promises to offer the best quality custom web application development 
                services at the most competitive pricing. We use the latest web application frameworks 
                (both the frontend and backend) for our website design and custom website development. 
                <br></br><br></br>From small businesses to leading enterprises. We develop and provide clients a business goal and 
                strategic approach to driving qualified traffic, thereby leading to business growth and better ROI. 
                <br></br><br></br>Our professional website developers and project managers possess significant expertise to implement modern 
                programming languages for promising cloud-based web solutions. We assure secure, reliable and easy to maintain web enabled solutions delivery. 
                </h5>
                <br />
                
              </Col>
            </Row>
            <br />
            <br />
            
          </Container>
        </div>
       
        <ContactComponent />
      </div>
     
      <FooterNav />
    </>
    
  );
}

export default WebDevelopment;
